module.exports = __webpack_public_path__ + "img/Monte_Kope_76.8043cd5c.jpg";